import { render, staticRenderFns } from "./ConfigFolio.vue?vue&type=template&id=6b847610&"
import script from "./ConfigFolio.vue?vue&type=script&lang=js&"
export * from "./ConfigFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports